export default __webpack_public_path__ + "static/careers_background-fd31f49788f88c50f427abb9b425268a.jpg";